var BaseViews = require('../base');
var OrderItems = require('./order-items');

var ActiveOrders = BaseViews.LayoutView.extend({
    className: 'fmcy-active-orders',
    template: require('./active-orders/active-orders.html'),
    initialize: function(options) {
        var self = this;
        this.options = _.defaults(
            options || {},
            {
                theme: 'dark',
                collection: null,
                _appChannel: null
            }
        );
    },
    regions: {
        ordersRegion: '.fmcy-orders-region',
    },
    _renderOrders: function () {
      var self = this;
      this._orderItems = new OrderItems({
        collection: this.options.collection,
        _appChannel: this.options._appChannel
      });
      this.ordersRegion.show(this._orderItems);

    },
    onRender: function() {
      this._renderOrders();
      BaseViews.LayoutView.prototype.onRender.call(self);
    }
});

module.exports = ActiveOrders;



/** WEBPACK FOOTER **
 ** ./assets/js/common/orders/active-orders.js
 **/